/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import redux_from_spaghetti_to_reducerImg from 'assets/images/redux-from-spaghetti-to-reducer.png'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Введение</h2>
    <p className={styles.description}>
      Требования к функционалу приложений постоянно растут, в результате растет количество состояний интерфейса:
      асинхронная загрузка данных, лоадеры, фильтры и т. п.{' '}
    </p>
    <p className={styles.description}>
      За всем этим необходимо следить и обрабатывать, и это не просто. В один момент можно просто перестать улавливать
      связь между изменениями, так как контроль над тем, когда, почему и как изменилось состояние потерян из-за
      сложности самого состояния.{' '}
    </p>
    <p className={styles.description}>
      Идеальный вариант, это когда интерфейс вообще не знает о бизнес-логике. В этом нам помогают библиотеки управления
      состоянием. <b>Redux</b> и <b>Mobx</b> самые популярные, а для бекендов основаных на <b>GraphQL</b> есть{' '}
      <b>Apollo</b>.{' '}
    </p>
    <img className={styles.img} src={redux_from_spaghetti_to_reducerImg} alt="redux-from-spaghetti-to-reducer" />
  </section>
))
